import { render, staticRenderFns } from "./CooperatePersonSelect.vue?vue&type=template&id=8c8c26c6&scoped=true&"
import script from "./CooperatePersonSelect.vue?vue&type=script&lang=js&"
export * from "./CooperatePersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./CooperatePersonSelect.vue?vue&type=style&index=0&id=8c8c26c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8c26c6",
  null
  
)

export default component.exports